import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Simple initialization without MSAL
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
